export default {
      id: "telegram-bot-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "img/icons.svg#telegram-bot",
      toString: function () {
        return this.url;
      }
    }